<template>
    <v-container>
        <v-layout>
            <v-tooltip top>
                <v-btn
                        class="mr-2 mb-2"
                        @click="newUser"
                        color="customPurple"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        slot="activator"
                >
                    <v-icon>add</v-icon>
                </v-btn>
                <span>Crear Usuario</span>
            </v-tooltip>
            <v-flex>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Crear nuevo Usuario</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="login"
                                            label="Usuario"
                                            id="login"
                                            v-model="user.login"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="email"
                                            label="Email"
                                            id="email"
                                            :rules="emailRules"
                                            v-model="user.email"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="nombre"
                                            label="Nombres"
                                            id="name"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 150) || 'El número de caracteres debe ser menor a 150']"
                                            v-model="user.firstName"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="apellido"
                                            label="Apellido"
                                            id="lastName"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 150) || 'El número de caracteres debe ser menor a 150']"
                                            v-model="user.lastName"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="identification"
                                            label="Identificación"
                                            id="identification"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length == 10) || 'El número de caracteres debe ser menor a 10']"
                                            v-model="user.identification"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="degree"
                                            label="Título"
                                            id="degree"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                            v-model="user.degree"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="specialty"
                                            label="Especialidad"
                                            id="specialty"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                            v-model="user.specialty"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="position"
                                            label="Cargo"
                                            id="position"
                                            :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                            v-model="user.position"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            :items="this.$store.getters.getCompanies"
                                            v-model="company"
                                            label="Seleccione una Empresa"
                                            single-line
                                            item-text="name"
                                            item-value="id"
                                            :rules="[v => !!v || 'Campo requerido']"
                                            return-object
                                            persistent-hint
                                            required
                                    >
                                    </v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-combobox
                                            :items="this.$store.state.allRols"
                                            v-model="userRols"
                                            label="Seleccione "
                                            multiple
                                            chips
                                            hint="Roles del Usuario"
                                            persistent-hint
                                    ></v-combobox>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <div id="app">
                                        <img :src="previewImage" class="uploading-image" width="100px" height="100px" />
                                        <input type="file" accept="image/jpeg" @change=uploadImage>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-switch
                                            label="Inactivo / Activo"
                                            v-model="user.activated"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData" large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de usuarios</h3>
        <v-data-table
                :headers="headers"
                :items="$store.state.users"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.id }}</td>
                <td class="text-xs-left">{{ props.item.login }}</td>
                <td class="text-xs-left">{{ props.item.firstName }}</td>
                <td class="text-xs-left">{{ props.item.lastName }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.activated?"Activo":"Inactivo" }}</td>
                <td class="text-xs-left">
                    <ul id="example-1">
                        <li v-for="role in props.item.authorities" v-bind:key="role" style="list-style-type: none;">
                            {{ role }}
                        </li>
                    </ul>
                </td>
                <td class="text-xs-left">
                    <div style="width:8rem;">
                        <v-tooltip top>
                            <v-btn
                                    fab dark
                                    small @click="editItem(props.item)"
                                    slot="activator"
                                    color="primary">
                                <v-icon dark>edit</v-icon>
                            </v-btn>
                            <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </div>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>
    import User from "../../model/User";
    import Company from "../../model/Company";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                date: '',
                menu: false,
                documentValidation: "",
                documentRules: [],
                codeRules: [
                    v => !!v || 'El código es requerido',
                    v => (v && v.length <= 50) || 'El código debe tener menos de 50 caracteres'
                ],
                emailRules: [
                    v => !!v || 'El email es requerido',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
                ],
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                headers: [
                    {text: 'Id', value: 'id'},
                    {text: 'Código de usuario', value: 'login'},
                    {text: 'Nombres', value: 'firstName'},
                    {text: 'Apellidos', value: 'lastName'},
                    {text: 'Email', value: 'email'},
                    {text: 'Estado', value: 'activated'},
                    {text: 'Rol', value: 'authorities'},
                    {text: 'Acciones', value: 'editar'},
                ],
                editedIndex: -1,
                user: new User(),
                userRols: [],
                company: new Company(),
                previewImage:null
            };
        }, methods: {
            cleanData() {
                this.$refs.form.reset()
                this.user = new User()
                this.company = new Company()
                this.valid = false
                this.dialog = false
                this.date = ""
            },
            newUser() {
                this.company = new Company()
                this.editedIndex = -1
                this.valid = false
                this.dialog = true
                this.$refs.form.reset()
                this.date = ""
                this.user = new User()

            },
            saveData() {
                if (this.validUser()) {
                    if (this.$refs.form.validate()) {
                        this.user.company = this.company.id
                        this.user.authorities = this.userRols
                        if(this.previewImage!=null){
                          this.user.photo = this.previewImage.replace("data:image/jpeg;base64,", "");
                        }
                        if (this.editedIndex > -1) {
                            this.$store.dispatch('updateUser', this.user).then(response => {
                                    this.cleanData();
                                },
                                error => {
                                    this.$store.state.progress = false;
                                    this.$store.state.dialogError = true;
                                });
                        } else {
                            this.$store.dispatch('addUser', this.user).then(response => {
                                    this.cleanData();
                                },
                                error => {
                                    this.$store.state.progress = false;
                                    this.$store.state.dialogError = true;
                                });
                        }
                        this.dialog = false
                    }
                }
            },
            editItem(item) {
                this.editedIndex = this.$store.state.users.indexOf(item)
                this.user = Object.assign({}, item)
                this.userRols = this.user.authorities
                this.previewImage = "data:image/jpeg;base64,"+this.user.photo
                for (let i = 0; i < this.$store.state.companies.length; i++) {
                    this.company = this.$store.state.companies[i]
                    let hasCompany = false
                    if (this.company.id === this.user.company) {
                        hasCompany = true
                        break
                    }
                    if (!hasCompany) {
                        this.company = {id: '', code: '', name: ''}
                    }
                }
                this.dialog = true
            },
            deleteItem(item) {
                this.editedIndex = this.$store.state.users.indexOf(item)
                this.user = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteUser', this.user.login).then(response => {
                    this.cleanData()
                    this.$router.push({name: 'user'})
                })
            },
            validUser() {
                if (!this.validarCedula()) {
                    return false;
                }
                if (this.editedIndex > -1 && this.validarCedula()) {
                    return true
                }
                for (var i = 0; i < this.$store.state.users.length; i++) {
                    if (this.$store.state.users[i].login == this.user.email) {
                        this.$store.state.dialogErrorMessage = "Usuario ya registrado en el sistema, intente con otro email"
                        this.$store.state.progress = false
                        this.$store.state.dialogError = true
                        return false
                    }
                }
                return true
            },
            validarCedula() {
                let cad = this.user.identification;
                let total = 0;
                let longitud = cad.length;
                let longcheck = longitud - 1;
                if (cad !== "" && longitud === 10) {
                    for (let i = 0; i < longcheck; i++) {
                        if (i % 2 === 0) {
                            let aux = cad.charAt(i) * 2;
                            if (aux > 9) aux -= 9;
                            total += aux;
                        } else {
                            total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                        }
                    }
                    total = total % 10 ? 10 - total % 10 : 0;

                    if (cad.charAt(longitud - 1) != total) {
                        this.$store.state.dialogErrorMessage = "Cédula inválida";
                        this.$store.state.dialogError = true
                        return false;
                    }
                    return true;
                }
            },
            uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.previewImage = e.target.result;
                };
            }
        },
        computed: {},
        beforeCreate() {
            this.$store.dispatch('getRols').then(response => {
            })
            this.$store.dispatch('getUsers').then(response => {
            })
            this.$store.dispatch('getCompanies').then(response => {
            })
        }
    }
</script>

<style scoped>
    td {
        width: 50px;
    }


</style>



// WEBPACK FOOTER //
// src/components/user/User.vue